<template>
  <Toast />
    <div class="card m-4">
      <div class="col-span-12">

        <div class="col-span-6 ml-4">
          <label for="nombre-name" class="block text-sm font-medium text-gray-700"> Empresa/Afiliado</label>
          <InputSwitch inputId="nombre-name" v-model="data.save.esEmpresa" @change="cambioEmpresa()" /> <span class="text-xs">{{ textEsEmpresa }}</span>
        </div>
  
        <div class="col-span-1">
          <label for="CodigoBarra">C&oacute;digo de Barra o N&ordm; Comprobante</label>

          <InputText id="CodigoBarra" type="text" v-model="data.save.codBarra" class="w-full" maxlength="50" @change="completarInfo()"/>

        </div>
        <br />
        <div class="flex mb-4">
            <label for="cuitData" class="p-3 text-center">CUIT: </label>
            <InputText v-model="cuit" class="w-1/4 text-center" id="cuitData" type="text" disabled />
            <InputText v-model="nombre" class="w-1/2 text-center" id="nombreData" type="text" disabled />
        </div>

        <div v-show="data.load">

                 <DataTable :value="dataModel" editMode="cell"
                @cell-edit-complete="onCellEditComplete" tableClass="editable-cells-table">

                <template #header>
                    <div class="sm:flex flex-wrap">
                        <div class="sm:flex-grow h-16">
                            <Button type="button" label="Actualizar datos" icon="pi pi-refresh" class="p-button-text p-button-sm" @click="mostrarCtaCte(data.idAfiliado);" />
                        </div>
                    </div>

                    
                </template>

                <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header" style="width: 15%">
                  <template #body="{ data, field }">
                      {{ field === 'price' ? formatCurrency(data[field]) : data[field] }}
                  </template>
                  <template #editor="{ data, field }">
                      <template v-if="field !== 'price'">
                          <InputText v-model="data[field]" autofocus />
                      </template>
                      <template v-else>
                          <InputNumber v-model="data[field]" mode="currency" currency="USD" locale="en-US" autofocus />
                      </template>
                  </template>
                </Column>
                
                <custom-component :data="data.item"></custom-component>

                <ColumnGroup type="footer">
                <Row>
                  <Column footer="Total:" :colspan="4" footerStyle="text-align:right"/>
                  <Column :footer="saldoTotal" />
                </Row>
              </ColumnGroup>
            </DataTable>
            <br/>
            <label for="Observaciones" class="">Observación: </label>
            <Textarea v-model="valueTextArea" :autoResize="true" rows="30" class="w-1/2 p-4" id="Observaciones" />
            <br/>
            <br/>
            <div class="w-full text-center">
              <Button type="button" label="Grabar nota de Credito" icon="pi pi-save" @click="Confirm()" class="w-1/4"/>
              <Button type="button" label="Cancelar" icon="pi pi-times" class="p-button-danger w-1/8"  />
            </div>
          </div>
          <br/>
      </div>
    </div>

    <Toast position="bottom-center" group="bc">
      <template #message="slotProps">
          <div class="w-full">
              <div class="w-full">
                <i class="pi pi-exclamation-triangle" style="font-size: 5rem"></i>
                <h4>{{slotProps.message.summary}}</h4>
                <p>{{slotProps.message.detail}}</p>
              </div>
              <br/>
              <div class="w-full">
                  <div class="w-full">
                      <Button class="p-button-success" label="Si" @click="onConfirm" style=" width: 100%; margin-bottom: .5rem;"></Button>
                      <Button class="p-button-secondary" label="No" @click="onReject" style=" width: 100%; margin-bottom: .5rem;"></Button>
                  </div>
              </div>
          </div>
      </template>
    </Toast>

  </template>
  <script>
    import { reactive, ref, onMounted } from 'vue';
    import InputText from 'primevue/inputtext';
    import BlockUI from 'primevue/blockui';
    import Textarea from 'primevue/textarea';
    import Button from 'primevue/button';
    import Tag from 'primevue/tag';
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';
    import Row from 'primevue/row';
    import ColumnGroup from 'primevue/columngroup';
    import InputNumber from 'primevue/inputnumber';
    import InputSwitch from 'primevue/inputswitch';
    import Toast from 'primevue/toast';
    import { useToast } from 'primevue/usetoast';
    import WService from '@/plugins/ws';

    import { isProxy, toRaw } from 'vue';



  
    export default {
      components: {
        InputText, BlockUI, Textarea, Button, Tag, DataTable, Column, InputNumber, InputSwitch, Toast, Row, ColumnGroup,
      },
      data() {
    return {
      dataImportePaga: ''
    }},
     
      
      setup() {
        onMounted(() => {
        intialLoad();
      })
        const toast = useToast();
        const wService = ref(new WService());
        const dt = ref(); //referencia a la tabla.
        const dataModel = ref(); //Datos de la tabla
        const selectedDatas = ref(); //Datos que seleccione
        const cuit = ref();
        const nombre = ref("");
        const saldoTotal = ref();
        const valueTextArea = ref("");

        const dataImportePaga = ref();
        var tipo = 0;
        let ntcredito = "";
        const textEsEmpresa = ref("Afiliado");
        const columns = ref([
            { field: 'periodo', header: 'Periodo' },
            { field: 'comprobante', header: 'Comprobante' },
            { field: 'tipoComprobante', header: 'Detalle' },
            { field: 'importe', header: 'Importe' },
            { field: 'pagado', header: 'Credito de...' }
        ]);
        var periodoNC = ref("");

        const data = reactive ({
          save : {
            esEmpresa: false,
            codBarra: "",
          },
          load: false,
        })

        const intialLoad = () => {
            wService.value.getMethod('Users/Extras/Fecha/' + "yyyy-MM-dd/" + "iosepSalud").then(info => {
            data.desde = new Date(info.desde + "T00:00");
            data.hasta = new Date(info.hasta + "T00:00");
            }).catch(err => {
            console.log(err.message);
            });
        }

        //formato de fecha
        const formatDate = value => {
            let [dateValues, timeValues] = ["0000000","0000000"];
            if(value == undefined || value == null){
            //nada
            }else{
            [dateValues, timeValues] = value.split('T');
            //const [month, day, year] = dateValues.split('/');
            //const [hours, minutes, seconds] = timeValues.split(':');
            }
            return dateValues;
        }

        const cleanCtaCte = () => {
          cuit.value = "";
          nombre.value = "";
          saldoTotal.value = "";
          valueTextArea.value = ""
          dataImportePaga.value = null;
          data.save.codBarra = "";
          dataModel.value = null;
          data.load = false;
        }

        const completarInfo = (event) => {
          if(!data.save.esEmpresa){

            wService.value.getMethod('Comprobantes/NotaCredito/' + data.save.codBarra).then(info => {
              
              
              if(info.length > 0){
                tipo = 1;
                cuit.value = info[0].cuil;
                nombre.value = info[0].nombre;
                dataModel.value = info;
                periodoNC = info[0].periodo;
                calcularImporte(info);
                

                data.load = true;
              }else{
                toast.add({severity:'error', summary: 'Mensaje de error', detail:'Afiliado no encontrado', life: 3000});
              }
            }).catch(err => {
              console.log(err.message);
            });
          }else{
            wService.value.getMethod('Comprobantes/NotaCreditoEmpresa/'+ data.save.codBarra).then(info => {
              //console.log(info);
              if(info.length > 0){
                cuit.value = info[0].cuil;
                nombre.value = info[0].nombre;
                dataModel.value = info;
                calcularImporte(info);
                data.load = true;
              }else{
                toast.add({severity:'error', summary: 'Mensaje de error', detail:'Cuenta Empresa no encontrada', life: 3000});
              }
            }).catch(err => {
              console.log(err.message);
            });
          }

        };

        //da formato a moneda
        const formatCurrency = value => {
          if (value)
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          return;
        };

        //calcula total del saldo
        const calcularImporte = value => {
          let total = 0;
          if(value.length > 0){
            console.log(dataModel);
            for (let item of value) {

              total = total + item.importe;

            }
            saldoTotal.value = formatCurrency(total);
          }
        };

        const cambioEmpresa = (event) => {
          if(!data.esEmpresa){
            data.esEmpresa = true;
            textEsEmpresa.value = "Empresa";
          }else{

            data.esEmprerawObjectsa = false;
            textEsEmpresa.value = "Afiliado";
          }vueObject

          cleanCtaCte();
        }
        
        const Confirm = (event) => {

          
          console.log (dataModel);
          const x = (dataModel);
          console.log(x);
          
          if(typeof cuit.value != 'undefined' && cuit.value != "" ){
            if(valueTextArea.value != ""){
              if(dataImportePaga.value != ""){
                  toast.add({severity: 'warn', summary: 'Está seguro?', detail: 'Si confirma los cambios serán permanentes', group: 'bc'});
                }else{
                  toast.add({severity:'error', summary: 'Mensaje de error', detail:'Debe colocar un importe a pagar', life: 3000});
                }
              }else{
                toast.add({severity:'error', summary: 'Mensaje de error', detail:'Debe colocar una observación', life: 3000});
             }

          }else{
            toast.add({severity:'error', summary: 'Mensaje de error', detail:'Cuil no cargado', life: 3000});
          }
        }
        const onConfirm = (event) => {
         let body = {};

        if (tipo == 1) {
          const rows = dataModel.value.map(e => ({
          IdDetalle: e.idDetalle,
          Periodo: e.periodo,
          IdComprobante: e.comprobante,
          Importe: e.importe,
          Pagado: e.pagado
       }));
          body = { rows };  
       } else { 
          body = { rows: [] };  
          ntcredito = dataModel.value[0].pagado;
      }

      const url = `Comprobantes/GuardarNotaCredito/${data.save.codBarra}/${tipo}/${valueTextArea.value}`;

        wService.value.postMethod(url, body).then(info => {
          console.log("info:", info);
           tipo = 0;
           if (info !== "error") {
            toast.add({
            severity: 'success',
            summary: 'Mensaje exitoso',
            detail: 'Nota de crédito guardada',
            life: 5000
          });
          toast.removeGroup('bc');
          cleanCtaCte();
          } else {
          toast.add({
          severity: 'error',
          summary: 'Mensaje de error',
          detail: 'Error al guardar nota de crédito',
          life: 5000
          });
        }
        }).catch(err => {
        console.log(err.message);
        });
        }; 
        
        const onReject = (event) => {
          toast.removeGroup('bc');
        }


        const onCellEditComplete = (event) => {
          let { data, newValue, field } = event;

          switch (field) {
              case 'pagado':
                  if (isPositiveInteger(newValue)) data[field] = newValue;
                  else event.preventDefault();
                  break;

              default:
                  /* if (newValue.trim().length > 0) data[field] = newValue;
                  else event.preventDefault(); */
                  break;
          }
      };

      const isPositiveInteger = (val) => {
          let str = String(val);

          str = str.trim();

          if (!str) {
              return false;
          }

          str = str.replace(/^0+/, '') || '0';
          var n = Math.floor(Number(str));

          return n !== Infinity && String(n) === str && n >= 0;
      };

        const vueObject = {
                   
                   dataJson() {
                    return {
                    rows: [{'IdDetalle': dataImportePaga.value, 'Periodo': 2, 'IdComprobante': 3, 'Importe': 4, 'Pagado': 5}]
                     }
                   }
                  }
  
        return {
          data, dataModel, selectedDatas, nombre, valueTextArea, cuit, textEsEmpresa, saldoTotal, columns,tipo,ntcredito,

          onCellEditComplete, isPositiveInteger, intialLoad, formatDate, cleanCtaCte,completarInfo, cambioEmpresa, onConfirm, onReject, formatCurrency, calcularImporte, Confirm,dataImportePaga,periodoNC,

        };
      }
    }
  </script>
